import { request } from '@umijs/max';

// 获取用户列表
export async function getAdmUserPage({
  pageSize,
  current,
  filter,
  sorter,
}: {
  pageSize: number;
  current: number;
  filter: API.FormValues;
  sorter: string;
}) {
  return request('/api/super/supUser/page', {
    method: 'POST',
    data: {
      pageSize,
      current,
      filter,
      sorter,
    },
  });
}


// 获取用户详情
export async function getAdmUserInfo(values: API.FormValues) {
  return request('/api/super/supUser/info', {
    method: 'POST',
    data: values,
  });
}

// 创建用户
export async function addAdmUser(values: API.FormValues) {
  return request('/api/super/supUser/add', {
    method: 'POST',
    data: values,
  });
}

// 编辑用户
export async function editAdmUser(values: API.FormValues) {
  return request('/api/super/supUser/edit', {
    method: 'POST',
    data: values,
  });
}

// 删除用户
export async function removeAdmUser(values: API.FormValues) {
  return request('/api/super/supUser/remove', {
    method: 'POST',
    data: values,
  });
}

// 清空失败次数
export async function clearFailAdmUser(values: API.FormValues) {
  return request('/api/super/supUser/clearFail', {
    method: 'POST',
    data: values,
  });
}
